(function($){
	$(function() {
	///////////////////////////////////////////////////////
			$('.home .primary-header').addClass('primary-header-white');
			var pageLargeur = $(window).width();
			var pageHauteur = $(window).height();
			var lastScrollTop = 0;

			$( window ).on( "scroll", function(){
				var posscrool = $( this ).scrollTop();

			//scroll vers le bas
				if( posscrool > lastScrollTop ){
							if(posscrool>=(pageHauteur - 75)) {
								$('.home .primary-header').removeClass('primary-header-white');
							}
				}
			//scroll vers le haut
					else{
						if(posscrool<=(pageHauteur - 75)) {
							$('.home .primary-header').addClass('primary-header-white');
						}
				}
				lastScrollTop = posscrool;
			});
	///////////////////////////////////////////////////////
	});
})(jQuery);
